@import '~style-sheet-helpers/core.less';
@import '../../../constants/spacing.module.less';

.body {
  gap: @space-12;
}

.recommendation-number {
  font-weight: 700;
  margin-right: @space-4;
}

.recommendation {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.recommendation-actions {
  display: flex;
  gap: @space-12;
}

.save-message > * {
  display: inline-block;
}

.row {
  gap: @space-12;
}

.half {
  flex-grow: 1;
  max-width: 50%;
}

.red {
  color: var(--red-600);
}

.loading-indicator {
  height: 100%;
  width: 100%;
  min-height: 300px;
  > * {
    min-height: 300px;
  }
}

.full-width-input {
  width: 100%;
}
